// src/pages/shipments/ShipmentDetailPage/ShipmentDetailPage.jsx
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import ShipmentsAPI from '../../../api/v3/shipments-api-v3'

const BASE = '/app/sales/bagspa'

function fmt(d){ return d ? new Date(d).toLocaleString('id-ID') : '-' }

const SHIPMENT_METHODS = [
  { value:'self_pickup', label:'Self Pickup' },
  { value:'gojek', label:'Gojek' },
  { value:'grab',  label:'Grab' },
  { value:'jne',   label:'JNE' },
  { value:'tiki',  label:'TIKI' },
]

export default function ShipmentDetailPage(){
  const { id } = useParams()
  const [shipment,setShipment] = useState(null)
  const [error,setError] = useState('')
  const [message,setMessage] = useState('')
  const [saving,setSaving] = useState(false)

  // dual reschedule forms
  const [cust,setCust] = useState({ scheduled_at:'', reason:'', shipment_type:'', customer_address_id:'' })
  const [vend,setVend] = useState({ scheduled_at:'', reason:'', shipment_type:'', customer_address_id:'' })

  async function load(){
    try{
      const res = await ShipmentsAPI.show(id)
      const s = res.item || res
      setShipment(s)
      setCust(c => ({ ...c, shipment_type: s.shipment_type || '', customer_address_id: s.customer_address?.id || '' }))
      setVend(v => ({ ...v, shipment_type: s.shipment_type || '', customer_address_id: s.customer_address?.id || '' }))
    }catch(e){ setError(e.message) }
  }
  useEffect(()=>{ load() },[id])

  async function doReschedule(target, payload){
    if(!payload.scheduled_at || !payload.reason){ alert('Isi tanggal/waktu dan alasan.'); return }
    try{
      setSaving(true)
      const res = await ShipmentsAPI.reschedule(id, {
        target,
        scheduled_at: payload.scheduled_at,
        reschedule_reason: payload.reason,
        shipment_type: payload.shipment_type || undefined,
        customer_address_id: payload.customer_address_id || undefined
      })
      setMessage(res.message || 'Schedule updated.')
      await load()
      setTimeout(()=>setMessage(''),2000)
    }catch(e){ setError(e.message) } finally{ setSaving(false) }
  }

  if(error) return <div className="alert alert-danger">{error}</div>
  if(!shipment) return <div>Loading…</div>

  const a = shipment.customer_address || {}
  const items = shipment.shipment_items || []

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Shipment #{shipment.id}</h3>
        <Link to={`${BASE}/shipments`} className="btn btn-light">&larr; Back</Link>
      </div>

      {message && <div className="alert alert-success">{message}</div>}

      {/* Summary */}
      <div className="card mb-3">
        <div className="card-body">
          <div><b>Order:</b> {shipment.order_no || `ORD-${shipment.order_id}`}</div>
          <div><b>Status:</b> {shipment.status}</div>
          <div><b>Type:</b> {shipment.shipment_type || '—'}</div>
          <div><b>Surat Jalan No:</b> {shipment.surat_jalan_no || '—'}</div>
          <div><b>Tanda Keluar No:</b> {shipment.tanda_keluar_no || '—'}</div>
          <hr/>
          <div><b>Customer Scheduled:</b> {fmt(shipment.customer_scheduled_at)}</div>
          <div><b>Customer Rescheduled:</b> {fmt(shipment.customer_rescheduled_at)}</div>
          <div><b>Vendor Scheduled:</b> {fmt(shipment.vendor_scheduled_at)}</div>
          <div><b>Reason:</b> {shipment.reschedule_reason || '—'}</div>
          <div><b>Updated:</b> {fmt(shipment.updated_at)}</div>
        </div>
      </div>

      {/* Address */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="mb-2">Delivery Address</h5>
          {a ? (
            <>
              <div><b>Alias:</b> {a.alias || '—'}</div>
              <div><b>Recipient:</b> {a.recipient_name || '—'}</div>
              <div><b>Phone:</b> {a.telephone || '—'}</div>
              <div><b>Address:</b> {a.street || '—'}</div>
              <div><b>Area:</b> {[a.subdistrict,a.district].filter(Boolean).join(', ') || '—'}</div>
              <div><b>City/Prov:</b> {[a.city,a.province].filter(Boolean).join(', ') || '—'}</div>
              <div><b>Postal:</b> {a.postal_code || '—'}</div>
            </>
          ) : <p className="text-muted mb-0">No address linked.</p>}
        </div>
      </div>

      {/* Items */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="mb-3">Shipment Items</h5>
          {items.length ? (
            <table className="table table-bordered table-sm">
              <thead>
                <tr>
                  <th style={{width:48}}>#</th>
                  <th>SKU</th>
                  <th>Brand</th>
                  <th>Category</th>
                  <th>Color</th>
                  <th style={{width:80,textAlign:'right'}}>Qty</th>
                  <th style={{width:120,textAlign:'right'}}>Base Price</th>
                  <th style={{width:120,textAlign:'right'}}>Line Total</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it,i)=>(
                  <tr key={it.id || i}>
                    <td>{i+1}</td>
                    <td>{it.product_sku || '—'}</td>
                    <td>{it.brand_name || '—'}</td>
                    <td>{it.category_name || '—'}</td>
                    <td>{it.colour_name || '—'}</td>
                    <td style={{textAlign:'right'}}>{it.quantity}</td>
                    <td style={{textAlign:'right'}}>{it.base_price!=null ? Number(it.base_price).toLocaleString() : '—'}</td>
                    <td style={{textAlign:'right'}}>{it.total_price!=null ? Number(it.total_price).toLocaleString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p className="text-muted mb-0">No items.</p>}
        </div>
      </div>

      {/* Reschedule - Customer */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="mb-3">Reschedule (Customer)</h5>
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Date/Time</label>
              <input type="datetime-local" className="form-control" value={cust.scheduled_at} onChange={e=>setCust(c=>({...c,scheduled_at:e.target.value}))}/>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shipment Method</label>
              <select className="form-control" value={cust.shipment_type} onChange={e=>setCust(c=>({...c,shipment_type:e.target.value}))}>
                <option value="">-- keep current --</option>
                {SHIPMENT_METHODS.map(m=><option key={m.value} value={m.value}>{m.label}</option>)}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Address ID (optional)</label>
              <input type="number" className="form-control" disabled="true" value="1" onChange={e=>setCust(c=>({...c,customer_address_id:e.target.value}))}/>
            </div>
            <div className="col-md-10">
              <label className="form-label">Reason</label>
              <input type="text" className="form-control" value={cust.reason} onChange={e=>setCust(c=>({...c,reason:e.target.value}))}/>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary w-100" disabled={saving} onClick={()=>doReschedule('customer',cust)}>{saving?'Saving…':'Reschedule'}</button>
            </div>
          </div>
        </div>
      </div>

      {/* Reschedule - Vendor */}
      <div className="card">
        <div className="card-body">
          <h5 className="mb-3">Reschedule (Vendor)</h5>
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Vendor Date/Time</label>
              <input type="datetime-local" className="form-control" value={vend.scheduled_at} onChange={e=>setVend(v=>({...v,scheduled_at:e.target.value}))}/>
            </div>
            <div className="col-md-4">
              <label className="form-label">Shipment Method</label>
              <select className="form-control" value={vend.shipment_type} onChange={e=>setVend(v=>({...v,shipment_type:e.target.value}))}>
                <option value="">-- keep current --</option>
                {SHIPMENT_METHODS.map(m=><option key={m.value} value={m.value}>{m.label}</option>)}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Address ID (optional)</label>
              {/* <input type="number" className="form-control" value={vend.customer_address_id} onChange={e=>setVend(v=>({...v,customer_address_id:e.target.value}))}/> */}
              <input type="number" className="form-control" disabled="true" value="1" onChange={e=>setCust(c=>({...c,customer_address_id:e.target.value}))}/>
            </div>
            <div className="col-md-10">
              <label className="form-label">Reason</label>
              <input type="text" className="form-control" value={vend.reason} onChange={e=>setVend(v=>({...v,reason:e.target.value}))}/>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary w-100" disabled={saving} onClick={()=>doReschedule('vendor',vend)}>{saving?'Saving…':'Reschedule'}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
